import { useLocation } from "react-router-dom"

export default function useQueryParam(param, getAll = false) {
  const searchParams = new URLSearchParams(useLocation().search)
  return getAll ? searchParams.getAll(param) : searchParams.get(param)
}
